import React, { useEffect, useRef, useState } from 'react';
import "./topheader.css";
import { 
    FaFacebookSquare, 
    FaInstagramSquare, 
    FaLinkedin, 
    FaWhatsappSquare, 
    FaPhoneSquare, 
    FaEnvelopeSquare 
} from 'react-icons/fa';

function Topbar() {
    const sliderRef = useRef(null);
    const [slideIndex, setSlideIndex] = useState(0);

    useEffect(() => {
        const interval = setInterval(() => {
            setSlideIndex(prevIndex =>
                (prevIndex + 1) % (sliderRef.current?.children.length || 1)
            );
        }, 4000);

        return () => clearInterval(interval);
    }, []);

    useEffect(() => {
        if (sliderRef.current) {
            sliderRef.current.style.transform = `translateX(-${slideIndex * 100}%)`;
        }
    }, [slideIndex]);

    return (
        <div className="announcement-bar">
            {/* Left Icons (Desktop Only) */}
            <div className="social-iconss">
                <a href="https://www.facebook.com/profile.php?id=61577395404506" target="_blank" rel="noopener noreferrer">
                    <FaFacebookSquare />
                </a>
                <a href="https://www.instagram.com/" target="_blank" rel="noopener noreferrer">
                    <FaInstagramSquare />
                </a>
                <a href="https://api.whatsapp.com/send?phone=918778934301" target="_blank" rel="noopener noreferrer">
                    <FaWhatsappSquare />
                </a>
                <a href="https://www.linkedin.com/in/farzana-rahman-b02a74352" target="_blank" rel="noopener noreferrer">
                    <FaLinkedin />
                </a>
            </div>

            {/* Center Scrolling Text */}
            <div className="announcement-slider-container">
                <div className="announcement-slider" ref={sliderRef}>
                    <p>Website Development starts at just ₹5999!</p>
                    <p>Get your Business Online Today!</p>
                    <p>E-Commerce Solutions at Affordable Prices!</p>
                </div>
            </div>

            {/* Right Icons (Desktop Only) */}
            <div className="social-iconss">
                <a href="tel:+918778934301" target="_blank" rel="noopener noreferrer">
                    <FaPhoneSquare />
                </a>
                <a href="https://api.whatsapp.com/send?phone=918778934301" target="_blank" rel="noopener noreferrer">
                    <FaWhatsappSquare />
                </a>
                <a href="mailto:info@eletiaa.com" target="_blank" rel="noopener noreferrer">
                    <FaEnvelopeSquare />
                </a>
            </div>
        </div>
    );
}

export default Topbar;
